// Mock data for GR8 website
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About GR8",
      services: "Services",
      portfolio: "Portfolio",
      whyChoose: "Why Choose GR8",
      testimonials: "Testimonials",
      serviceAreas: "Service Areas",
      contact: "Contact"
    },
    hero: {
      title: "Bring your ideas to life",
      subtitle: "the GR8 way!",
      description: "Premium remodeling and maintenance services in Los Cabos",
      cta: "Get a Free Quote",
      cta2: "Our Services"
    },
    about: {
      title: "About GR8",
      mission: "Our Mission",
      missionText: "To deliver exceptional remodeling and maintenance services that transform spaces and exceed expectations in Los Cabos.",
      vision: "Our Vision",
      visionText: "To be the most trusted and respected remodeling company in Baja California Sur, known for quality, reliability, and innovation.",
      approach: "Professional Approach",
      approachText: "We combine skilled craftsmanship with modern techniques to deliver results that stand the test of time."
    },
    services: {
      title: "Our Services",
      subtitle: "Comprehensive solutions for your property",
      painting: {
        title: "Interior & Exterior Painting",
        items: ["Interior walls & ceilings", "Exterior homes & buildings", "Cabinet painting & refinishing", "Trim, baseboards & doors", "Texture application & repair", "Surface preparation", "High-end finishes"]
      },
      carpentry: {
        title: "Carpentry",
        items: ["Custom cabinets", "Closets & wardrobes", "TV units & entertainment centers", "Coffee tables", "Built-in furniture", "Wood paneling", "Wood refinishing", "Door installation", "Decorative wood features"]
      },
      remodeling: {
        title: "Remodeling",
        items: ["Kitchen remodeling", "Bathroom remodeling", "Interior renovations", "Structural modifications", "Commercial remodeling"]
      },
      maintenance: {
        title: "Maintenance Services",
        items: ["Preventive maintenance", "Corrective maintenance", "Hotel maintenance support", "Electrical", "Plumbing", "Drywall repair", "General repairs"]
      },
      masonry: {
        title: "Masonry",
        items: ["Block & brick work", "Stone masonry", "Concrete work", "Retaining walls", "Outdoor fireplaces", "Paver installation", "Foundation repair", "Decorative stonework"]
      },
      construction: {
        title: "Construction",
        items: ["House extensions", "Swimming pools", "Water cisterns", "Water systems & plumbing", "AC installation & ductwork", "Room additions", "Garage construction", "Outdoor structures", "Foundation & structural work", "Roofing systems"]
      }
    },
    portfolio: {
      title: "Our Work",
      subtitle: "Before & After Transformations",
      viewMore: "View More Projects"
    },
    whyChoose: {
      title: "Why Choose GR8",
      subtitle: "Quality, Trust & Excellence",
      quality: {
        title: "Superior Quality",
        description: "We use premium materials and expert craftsmanship to ensure lasting results."
      },
      trust: {
        title: "Trusted & Reliable",
        description: "Transparent communication, honest pricing, and dependable service every time."
      },
      detail: {
        title: "Attention to Detail",
        description: "Every project receives meticulous care and precision from start to finish."
      },
      punctuality: {
        title: "On-Time Delivery",
        description: "We respect your time and consistently meet project deadlines."
      }
    },
    testimonials: {
      title: "What Our Clients Say",
      subtitle: "Real experiences from satisfied customers",
      items: [
        {
          name: "John Martinez",
          role: "Homeowner, Palmilla",
          text: "GR8 transformed our kitchen beyond our expectations. Professional, punctual, and exceptional quality work.",
          rating: 5
        },
        {
          name: "Sarah Thompson",
          role: "Realtor, Cabo San Lucas",
          text: "I recommend GR8 to all my clients. They consistently deliver high-quality renovations that add real value.",
          rating: 5
        },
        {
          name: "Linda Pryor",
          role: "Homeowner, El Tezal",
          text: "Outstanding craftsmanship and attention to detail. GR8 completed our home renovation on time and exceeded all expectations.",
          rating: 5
        }
      ]
    },
    serviceAreas: {
      title: "Service Areas",
      subtitle: "Proudly serving the entire South Coast of Los Cabos",
      description: "We proudly serve the entire South Coast of Los Cabos including:",
      areas: ["Cabo San Lucas", "San José del Cabo", "El Tezal", "Pedregal", "Palmilla", "Querencia", "Diamante", "Chileno Bay", "Puerto Los Cabos", "and surrounding areas"]
    },
    contact: {
      title: "Get Your Free Quote",
      subtitle: "Let's bring your vision to life",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        service: "Service Needed",
        message: "Project Details",
        submit: "Request Quote",
        selectService: "Select a service"
      },
      info: {
        title: "Contact Information",
        phone: "Phone",
        whatsapp: "WhatsApp",
        location: "Location",
        locationValue: "Los Cabos, Baja California Sur, Mexico"
      }
    },
    footer: {
      description: "Premium remodeling and maintenance services in Los Cabos. Bringing your ideas to life – the GR8 way!",
      quickLinks: "Quick Links",
      servicesTitle: "Services",
      followUs: "Follow Us",
      rights: "All rights reserved."
    }
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Sobre GR8",
      services: "Servicios",
      portfolio: "Portafolio",
      whyChoose: "Por Qué Elegirnos",
      testimonials: "Testimonios",
      serviceAreas: "Áreas de Servicio",
      contact: "Contacto"
    },
    hero: {
      title: "Dale vida a tus ideas",
      subtitle: "¡al estilo GR8!",
      description: "Servicios premium de remodelación y mantenimiento en Los Cabos",
      cta: "Cotización Gratuita",
      cta2: "Nuestros Servicios"
    },
    about: {
      title: "Sobre GR8",
      mission: "Nuestra Misión",
      missionText: "Entregar servicios excepcionales de remodelación y mantenimiento que transformen espacios y superen expectativas en Los Cabos.",
      vision: "Nuestra Visión",
      visionText: "Ser la empresa de remodelación más confiable y respetada en Baja California Sur, conocida por calidad, confiabilidad e innovación.",
      approach: "Enfoque Profesional",
      approachText: "Combinamos artesanía experta con técnicas modernas para entregar resultados que resisten el paso del tiempo."
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "Soluciones integrales para tu propiedad",
      painting: {
        title: "Pintura Interior y Exterior",
        items: ["Paredes y techos interiores", "Exteriores de casas y edificios", "Pintura y renovación de gabinetes", "Molduras, zócalos y puertas", "Aplicación y reparación de texturas", "Preparación de superficies", "Acabados de alta gama"]
      },
      carpentry: {
        title: "Carpintería",
        items: ["Gabinetes personalizados", "Closets y armarios", "Muebles para TV y entretenimiento", "Mesas de centro", "Muebles empotrados", "Paneles de madera", "Renovación de madera", "Instalación de puertas", "Elementos decorativos de madera"]
      },
      remodeling: {
        title: "Remodelación",
        items: ["Remodelación de cocinas", "Remodelación de baños", "Renovaciones interiores", "Modificaciones estructurales", "Remodelación comercial"]
      },
      maintenance: {
        title: "Servicios de Mantenimiento",
        items: ["Mantenimiento preventivo", "Mantenimiento correctivo", "Soporte de mantenimiento hotelero", "Eléctrico", "Plomería", "Reparación de drywall", "Reparaciones generales"]
      },
      masonry: {
        title: "Albañilería",
        items: ["Trabajo de block y ladrillo", "Mampostería de piedra", "Trabajo de concreto", "Muros de contención", "Chimeneas exteriores", "Instalación de adoquines", "Reparación de cimientos", "Piedra decorativa"]
      },
      construction: {
        title: "Construcción",
        items: ["Extensiones de casa", "Albercas", "Cisternas de agua", "Sistemas de agua y plomería", "Instalación de AC y ductos", "Adición de habitaciones", "Construcción de garajes", "Estructuras exteriores", "Trabajo de cimientos y estructura", "Sistemas de techos"]
      }
    },
    portfolio: {
      title: "Nuestro Trabajo",
      subtitle: "Transformaciones Antes y Después",
      viewMore: "Ver Más Proyectos"
    },
    whyChoose: {
      title: "Por Qué Elegir GR8",
      subtitle: "Calidad, Confianza y Excelencia",
      quality: {
        title: "Calidad Superior",
        description: "Usamos materiales premium y artesanía experta para asegurar resultados duraderos."
      },
      trust: {
        title: "Confiable y Seguro",
        description: "Comunicación transparente, precios honestos y servicio confiable siempre."
      },
      detail: {
        title: "Atención al Detalle",
        description: "Cada proyecto recibe cuidado meticuloso y precisión de inicio a fin."
      },
      punctuality: {
        title: "Entrega a Tiempo",
        description: "Respetamos tu tiempo y cumplimos consistentemente con los plazos del proyecto."
      }
    },
    testimonials: {
      title: "Lo Que Dicen Nuestros Clientes",
      subtitle: "Experiencias reales de clientes satisfechos",
      items: [
        {
          name: "John Martinez",
          role: "Propietario, Palmilla",
          text: "GR8 transformó nuestra cocina más allá de nuestras expectativas. Profesionales, puntuales y trabajo de calidad excepcional.",
          rating: 5
        },
        {
          name: "Sarah Thompson",
          role: "Agente Inmobiliario, Cabo San Lucas",
          text: "Recomiendo GR8 a todos mis clientes. Consistentemente entregan renovaciones de alta calidad que agregan valor real.",
          rating: 5
        },
        {
          name: "Linda Pryor",
          role: "Propietaria, El Tezal",
          text: "Artesanía excepcional y atención al detalle. GR8 completó la renovación de nuestra casa a tiempo y superó todas las expectativas.",
          rating: 5
        }
      ]
    },
    serviceAreas: {
      title: "Áreas de Servicio",
      subtitle: "Sirviendo con orgullo toda la Costa Sur de Los Cabos",
      description: "Servimos con orgullo toda la Costa Sur de Los Cabos incluyendo:",
      areas: ["Cabo San Lucas", "San José del Cabo", "El Tezal", "Pedregal", "Palmilla", "Querencia", "Diamante", "Chileno Bay", "Puerto Los Cabos", "y áreas circundantes"]
    },
    contact: {
      title: "Obtén Tu Cotización Gratuita",
      subtitle: "Hagamos realidad tu visión",
      form: {
        name: "Nombre Completo",
        email: "Correo Electrónico",
        phone: "Número de Teléfono",
        service: "Servicio Requerido",
        message: "Detalles del Proyecto",
        submit: "Solicitar Cotización",
        selectService: "Selecciona un servicio"
      },
      info: {
        title: "Información de Contacto",
        phone: "Teléfono",
        whatsapp: "WhatsApp",
        location: "Ubicación",
        locationValue: "Los Cabos, Baja California Sur, México"
      }
    },
    footer: {
      description: "Servicios premium de remodelación y mantenimiento en Los Cabos. ¡Dale vida a tus ideas – al estilo GR8!",
      quickLinks: "Enlaces Rápidos",
      servicesTitle: "Servicios",
      followUs: "Síguenos",
      rights: "Todos los derechos reservados."
    }
  }
};

export const portfolioProjects = [
  {
    id: 1,
    title: "Kitchen Remodel - Palmilla",
    category: "Remodeling",
    before: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80",
    after: "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80"
  },
  {
    id: 2,
    title: "Exterior Painting - Pedregal",
    category: "Painting",
    before: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800&q=80",
    after: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80"
  },
  {
    id: 3,
    title: "Custom Carpentry - Diamante",
    category: "Carpentry",
    before: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&q=80",
    after: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80"
  },
  {
    id: 4,
    title: "Bathroom Renovation - Cabo San Lucas",
    category: "Remodeling",
    before: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80",
    after: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800&q=80"
  }
];
